import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取站点规则配置分页数据
 * @param data
 *
 */
export const  getStationRulePage = (data) => {
    return request({
        url: env.ferryUrl + '/stationRuleAdmin/queryStationRulePage',
        //url: 'http://192.168.1.131:38000/stationRuleAdmin/queryStationRulePage',
        method: 'POST',
        data: data
    })
}


/**
 * 新增站点规则配置
 * @param data
 */
export const  addStationRule = (data) => {
    return request({
        url: env.ferryUrl + '/stationRuleAdmin/saveStationRule',
        //url: 'http://192.168.1.131:38000/stationRuleAdmin/saveStationRule',
        method: 'POST',
        data: data
    })
}


/**
 * 编辑站点规则配置
 * @param data
 */
export const  editStationRule = (data) => {
    return request({
        url: env.ferryUrl + '/stationRuleAdmin/editStationRule',
        //url: 'http://192.168.1.131:38000/stationRuleAdmin/editStationRule',
        method: 'PUT',
        data: data
    })
}

/**
 * 删除站点规则配置
 * @param stationRuleId
 */
export const  deleteStationRule = (stationRuleId) => {
    return request({
        url: env.ferryUrl + `/stationRuleAdmin/deleteStationRule/${stationRuleId}`,
        //url: `http://192.168.1.131:38000/stationRuleAdmin/deleteStationRule/${stationRuleId}`,
        method: 'PUT'
    })
}

/**
 * 根据线路id获取线路详情
 * @param lineId
 */
export const getRoteInfoById = (lineId) => {
    return request({
        url: env.ferryUrl + `/stationRuleAdmin/findLineByLineId/${lineId}`,
        //url: `http://192.168.1.131:38000/stationRuleAdmin/findLineByLineId/${lineId}`,
        method: 'get',
    })
}


/**
 * 判断站点规则能否删除
 *
 */
export const  ifDeleteStationRule = () => {
    return request({
        url: env.ferryUrl + '/stationRuleAdmin/judgeDeleteStationRule',
        //url: 'http://192.168.1.131:38000/stationRuleAdmin/judgeDeleteStationRule',
        method: 'PUT'
    })
}


/**
 * 查询站点规则名称是否重复
 */
export const getStationRuleIsRepeat = (LineStationRuleName) => {
    return request({
        url: env.ferryUrl + `/stationRuleAdmin/judgeLineStationRuleNameOnly/${LineStationRuleName}`,
        //url: `http://192.168.1.131:38000/stationRuleAdmin/judgeLineStationRuleNameOnly/${LineStationRuleName}`,
        method: 'get',
    })
}

/**
 * 编辑站点规则回显
 *
 */
export const  getStationRuleById = (stationRuleId) => {
    return request({
        url: env.ferryUrl + `/stationRuleAdmin/queryStationRuleById/${stationRuleId}`,
        //url: `http://192.168.1.131:38000/stationRuleAdmin/queryStationRuleById/${stationRuleId}`,
        method: 'PUT'
    })
}


/**
 *根据线路id获取所有站点
 */
export const  getStationRuleByRouteId = (lineId) => {
    return request({
        url: env.ferryUrl + '/stationRuleAdmin/queryStationRuleById',
        //url: 'http://192.168.1.131:38000/stationRuleAdmin/queryStationRuleById/${stationRuleId}',
        method: 'GET',
        param: lineId
    })
}


/**
 *获取所有线路
 */
export const  getAllRoute = () => {
    return request({
        url: env.ferryUrl + '/stationRuleAdmin/findAllLine',
        //url: 'http://192.168.1.131:38000/stationRuleAdmin/findAllLine',
        method: 'GET',
    })
}

/**
 *判断站点规则是否绑定价格方案
 */
export const  stationRuleIsBindPrice = (stationRuleId) => {
    return request({
        url: env.ferryUrl + `/stationRuleAdmin/judgeStationRuleBindPriceMethod/${stationRuleId}`,
        //url: `http://192.168.1.131:38000/stationRuleAdmin/judgeStationRuleBindPriceMethod/${stationRuleId}`,
        method: 'PUT'
    })
}



